<template>
  <div v-if="message" class="form-alert" role="alert">
    <!-- Иконка ошибки (Инлайн SVG без зависимостей) -->
    <div class="form-alert__icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="8" x2="12" y2="12"></line>
        <line x1="12" y1="16" x2="12.01" y2="16"></line>
      </svg>
    </div>

    <!-- Область текста ошибки -->
    <div class="form-alert__message">
      {{ message }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorAlert',
  props: {
    // Строка с текстом ошибки. Если пустая или null — компонент скрывается.
    message: {
      type: String,
      default: null
    }
  }
};
</script>

<style scoped>
.form-alert {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 14px;
  background-color: #fff5f5;
  border: 1px solid #feb2b2;
  border-radius: 6px;
  color: #c53030;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  font-size: 13.5px;
  line-height: 1.4;
  margin: 12px 0;
  box-sizing: border-box;
}

.form-alert__icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  margin-top: 1px; /* Выравнивание иконки по первой строке текста */
  color: #e53e3e;
}

.form-alert__icon svg {
  width: 16px;
  height: 16px;
}

.form-alert__message {
  flex-grow: 1;
  font-weight: 500;
  word-break: break-word; /* Защита от переполнения длинными строками */
}
</style>